<template>
  <div class="chat_room_promise_item">
    <div class="chat_table_box">
      <div class="chat_table_ttl">
        매장 방문 약속
      </div>
    </div>
    <div class="chat_table_box" v-if="promiseView">
      <div class="chat_visit_list">
        {{ visitPromiseModel.customerName }}
      </div>
      <div class="chat_visit_list">
        {{ visitPromiseModel.customerMobile }}
      </div>
      <div class="chat_visit_list">
        {{ visitPromiseModel.visitDate }} {{ visitPromiseModel.visitHour }} 방문
        예상
      </div>
    </div>
    <div class="chat_table_box" v-else>
      <div class="chat_visit_list">
        고객님의 인적사항이 비공개 전환되었습니다.
      </div>
    </div>
    <div class="chat_table_box chat_visit_notice">
      ※ 인적사항은 보름 후 비공개 전환되며, 접수내역 메뉴에서도 확인 가능합니다.
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    visitPromiseModel: Object,
    promiseCreatedAt: String,
  },
  data() {
    return {
      promiseView: true,
    };
  },
  created() {
    const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const createdAt = new Date(this.promiseCreatedAt);

    const sDays = format(
      new Date(createdAt.setDate(createdAt.getDate() + 15)),
      'yyyy-MM-dd HH:mm:ss',
    );

    if (now > sDays) {
      this.promiseView = false;
    } else {
      this.promiseView = true;
    }
  },
  mounted() {
    //alert(this.bookingModel);
  },
  methods: {},
};
</script>

<style></style>
